import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faMinusSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCaretLeft, faCheck, faFolder, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BLink, BModal, BPagination, BSpinner, BTable } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { SELECTION_STATES } from "@/components/SelectionDialog/selectionTypes";
import {} from "./selectionTypes";
import FilterMenu from "@/components/Common/FilterMenu.vue";
import Heading from "@/components/Common/Heading.vue";
import DataDialogSearch from "@/components/SelectionDialog/DataDialogSearch.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectionDialog',
    props: {
        disableOk: { type: Boolean, default: false },
        errorMessage: { default: "" },
        fileMode: { type: Boolean, default: true },
        fields: { default: () => [] },
        isBusy: { type: Boolean, default: false },
        isEncoded: { type: Boolean, default: false },
        items: { default: () => [] },
        itemsProvider: { default: undefined },
        providerUrl: { default: undefined },
        totalItems: { default: 0 },
        leafIcon: { default: "fa fa-file-o" },
        folderIcon: { default: () => faFolder },
        modalShow: { type: Boolean, default: true },
        modalStatic: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        optionsShow: { type: Boolean, default: false },
        undoShow: { type: Boolean, default: false },
        selectAllVariant: { default: SELECTION_STATES.UNSELECTED },
        showSelectIcon: { type: Boolean, default: false },
        title: { default: "" },
        searchTitle: { default: undefined },
        okButtonText: { default: "Select" },
        filterClass: { default: undefined },
        watchOnPageChanges: { type: Boolean, default: true }
    },
    emits: ["onCancel", "onClick", "onOk", "onOpen", "onSelectAll", "onUndo"],
    setup(__props, { expose, emit }) {
        const props = __props;
        library.add(faCaretLeft, faCheck, faCheckSquare, faFolder, faMinusSquare, faSpinner, faSquare, faTimes);
        const LABEL_FIELD = { key: "label", sortable: true };
        const SELECT_ICON_FIELD = { key: "__select_icon__", label: "", sortable: false };
        const filter = ref("");
        const currentPage = ref(1);
        const perPage = ref(25);
        const showAdvancedSearch = ref(false);
        const okButtonText = computed(() => {
            return props.okButtonText ? props.okButtonText : props.fileMode ? "Select" : "Select this folder";
        });
        const fieldDetails = computed(() => {
            const fields = props.fields.slice().map((x) => {
                x.sortable = x.sortable === undefined ? true : x.sortable;
                return x;
            });
            if (fields.length === 0) {
                fields.unshift(LABEL_FIELD);
            }
            if (props.showSelectIcon) {
                fields.unshift(SELECT_ICON_FIELD);
            }
            return fields;
        });
        function selectionIcon(variant) {
            switch (variant) {
                case SELECTION_STATES.SELECTED:
                    return faCheckSquare;
                case SELECTION_STATES.MIXED:
                    return faMinusSquare;
                default:
                    return faSquare;
            }
        }
        /** Resets pagination when a filter/search word is entered **/
        function filtered(items) {
            if (props.itemsProvider === undefined) {
                resetPagination();
            }
        }
        /** Format time stamp */
        function formatTime(value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleString("default", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                    minute: "numeric",
                    hour: "numeric",
                });
            }
            else {
                return "-";
            }
        }
        function resetFilter() {
            filter.value = "";
        }
        function resetPagination(toInitialPage = 1) {
            currentPage.value = toInitialPage;
        }
        if (props.watchOnPageChanges) {
            watch(() => props.items, () => {
                if (props.itemsProvider === undefined) {
                    resetPagination();
                }
            });
        }
        expose({
            resetFilter,
            resetPagination,
            currentPage,
        });
        return { __sfc: true, LABEL_FIELD, SELECT_ICON_FIELD, props, emit, filter, currentPage, perPage, showAdvancedSearch, okButtonText, fieldDetails, selectionIcon, filtered, formatTime, resetFilter, resetPagination, faCaretLeft, faCheck, faSpinner, faTimes, FontAwesomeIcon, BAlert, BButton, BLink, BModal, BPagination, BSpinner, BTable, FilterMenu, Heading, DataDialogSearch, StatelessTags };
    }
});
